export default __webpack_public_path__ + "static/media/cryptofont-webfont.3fd262a3.ttf";